/* GASSISA
=========================================================================================
* Descripcion: Menu principal exclusivo para Venta Super portatil.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de menu portatil independiente
*      2       | 08/09/2026 | Lic. Jose Luis Aragon Cervantes  | Boton Preventas junto a Salir para jalar preventas (Alt+J)
* ---------------------------------------------------------------------------------------
*/

import { Fragment } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import VerifiedIcon from "@mui/icons-material/Verified";
import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from "@mui/icons-material/Print";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import NextPlanIcon from "@mui/icons-material/NextPlan";
import { useNavigate } from "react-router-dom";
import { useVentas } from "../../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from "../../../hooks/useDoubleClickPrevention";

export default function MnuVentasActionsPortatil({ disabled, onOpenBuscador, onOpenReimpresion, onCobrar, onJalarPreventas }) {
  const navigate = useNavigate();
  const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
  const {
    handleClickRegresarMainDashboard,
    handleClickRefrescarDatosVenta,
    handleAbrirMenuModal,
    handleOpenModalLoginValidatorCortes,
    handleArirModalBuscarCliente,
    listaRemisionTemporal,
  } = useVentas();

  return (
    <Fragment>
      <Tooltip title="Salir"><IconButton onClick={handleClickRegresarMainDashboard}><HomeIcon className="icon" /><p className="icon">Salir</p></IconButton></Tooltip>
      <Tooltip title="Jalar Preventas (Alt+J)"><span><IconButton onClick={() => executeWithProtection(onJalarPreventas)} disabled={isProcessing || disabled}><NextPlanIcon className="icon" /><p className="icon">Preventas</p></IconButton></span></Tooltip>
      <Tooltip title="Buscar artículos"><span><IconButton onClick={onOpenBuscador} disabled={disabled}><SearchIcon className="icon" /><p className="icon">Artículos</p></IconButton></span></Tooltip>
      <Tooltip title="Buscar clientes"><span><IconButton onClick={handleArirModalBuscarCliente} disabled={disabled}><PersonSearchIcon className="icon" /><p className="icon">Clientes</p></IconButton></span></Tooltip>
      <Tooltip title="Devoluciones"><IconButton onClick={() => navigate("/devoluciones", { replace: true })}><AssignmentReturnIcon className="icon" /><p className="icon">Devoluciones</p></IconButton></Tooltip>
      {listaRemisionTemporal.length > 0 && <Tooltip title="Cobrar"><span><IconButton onClick={() => executeWithProtection(onCobrar)} disabled={isProcessing || disabled}><VerifiedIcon className="icon" /><p className="icon">Cobrar</p></IconButton></span></Tooltip>}
      <Tooltip title="Refrescar"><span><IconButton onClick={handleClickRefrescarDatosVenta} disabled={disabled}><RefreshIcon className="icon" /></IconButton></span></Tooltip>
      <Tooltip title="Reimprimir"><IconButton onClick={onOpenReimpresion}><PrintIcon className="icon" /><p className="icon">Reimprimir</p></IconButton></Tooltip>
      <Tooltip title="Corte de caja"><span><IconButton onClick={() => executeWithProtection(handleOpenModalLoginValidatorCortes)} disabled={isProcessing || disabled}><VerifiedIcon className="icon" /></IconButton></span></Tooltip>
      <Tooltip title="Otras acciones"><IconButton onClick={handleAbrirMenuModal}><DensitySmallIcon className="icon" /><p className="icon">Menu</p></IconButton></Tooltip>
    </Fragment>
  );
}
